import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import { cn } from "../../lib/utils";
const Separator = React.forwardRef(({ className, orientation = "horizontal", decorative = true, ...props }, ref) => {
    const dimension = orientation === "horizontal" ? { height: "1px", width: "100%" } : { width: "1px", height: "100%" };
    return (<SeparatorPrimitive.Root ref={ref} decorative={decorative} orientation={orientation} className={cn("va-separator", className)} style={dimension} {...props}/>);
});
Separator.displayName = SeparatorPrimitive.Root.displayName;
export { Separator };
